import React, { HTMLAttributes, ReactElement } from 'react'
import { LayoutTopPaneType } from './types-and-constants/LayoutPaneTypesAndConstants'
import { getRetainBehaviorModifierForPane } from '../helpers/get-retain-behavior-for-pane'
import { Retain } from '../../../atoms/Retain/Retain'
import { RetainBehaviorModifier } from '../../../atoms/Retain/constants/modifiers'

interface Props extends Omit<HTMLAttributes<HTMLDivElement>, 'className'> {
    paneType: LayoutTopPaneType
    children?: ReactElement | ReactElement[]
    customRetainBehaviorModifier?: RetainBehaviorModifier
}

export const LayoutTopPaneRSC = ({
    paneType,
    children,
    customRetainBehaviorModifier,
    ...props
}: Props): ReactElement => {
    if (!paneType) {
        console.error('LayoutTopPane must be defined for the Layout to read it.')
    }

    const topPaneClasses = [
        'o-layout__top-pane',
        paneType === LayoutTopPaneType.TOP_PANE_FIXED && 'o-layout__top-pane--fixed',
        paneType === LayoutTopPaneType.TOP_PANE_STICKY && 'o-layout__top-pane--sticky',
    ]
        .filter((i) => !!i)
        .join(' ')

    return (
        <div {...props} className={topPaneClasses}>
            <Retain
                behaviorModifiers={[customRetainBehaviorModifier ?? getRetainBehaviorModifierForPane(paneType)]}
                className="h-full"
                behaviorOnly
            >
                {children ?? <></>}
            </Retain>
        </div>
    )
}
